import ErrorMessage from "./ErrorMessage";
import Label from "./Label";
import { Controller } from "react-hook-form/dist/index.ie11";
import Select from "react-select";
import { useFormContext } from "./FormProvider";
import { v4 as uuidv4 } from "uuid";

const UUID = uuidv4();

SelectInput.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  rules: PropTypes.object,
  options: PropTypes.array,
  className: PropTypes.string,
};

SelectInput.defaultProps = {
  className: "",
  backgroundColor: "",
};

export default function SelectInput({
  name,
  placeholder,
  label,
  options = [],
  rules,
  className,
}) {
  const { control, errors } = useFormContext();
  const id = `${name}__${UUID}`;

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ onChange, value }) => {
        return (
          <div className={"field field-select " + className}>
            <Label value={label} htmlFor={id} />
            <div className={"control"}>
              <Select
                inputProps={{ id }}
                aria-labelledby="aria-label"
                name={name}
                label={label}
                placeholder={placeholder}
                value={options.find((rec) => rec.value === value)}
                onChange={(selected) =>
                  onChange(selected ? selected.value : null)
                }
                options={options}
                classNamePrefix={"select"}
                className={"select"}
                isSearchable={false}
              />
            </div>
            <ErrorMessage error={errors[name]} />
          </div>
        );
      }}
    />
  );
}
